import {signalStore, withState} from "@ngrx/signals";
import {fetchOnInit} from "./features/fetchOnInit.feature.store";
import {InstallationProfile} from "../types/installation-profile.type";

type InstallationProfilesStoreState = {
    installationProfiles: Array<InstallationProfile>,
}

export const assemblyProfilesStore = signalStore(

    { providedIn: "root" },

    withState<InstallationProfilesStoreState>({
        installationProfiles: [],
    }),

    fetchOnInit<InstallationProfilesStoreState, ['installationProfiles'], InstallationProfile>(
        '/api/product?productType=Frame profile',
        ['installationProfiles']
    ),
);
